import { withDataConverter } from '@beef/react';
import { compose } from '@beef/utils';
import { getPaymentSum } from "../../../store/common/selectors";
import { getSberPayErrorText } from "../../../store/features/sberpay/selectors";
import { store } from "../../../store/store";
import { findFirst } from "../../../utils/arrays";
import { onPaymentModalErrorAnalyticsHandler, onPaymentModalSuccessAnalyticsHandler } from '.';
export var withAnalytics = compose(withDataConverter(function (data) {
  var isError = data.isError;
  var state = store.getState();
  var sum = getPaymentSum(state);
  var error = getSberPayErrorText(state);
  var handler = findFirst([isError && function () {
    return onPaymentModalErrorAnalyticsHandler(error);
  }, isError === false && function () {
    return onPaymentModalSuccessAnalyticsHandler("".concat(sum));
  }]);
  handler === null || handler === void 0 || handler();
  return data;
}));